export const ComparedDurationLegendTemplate = (props) => {
    const { legendItems } = props;

    return (
        <div className="swWidget-legend">
            <div className="legend compared-duration-legend">
                {legendItems?.map((item, index) => {
                    return (
                        <div
                            className="legend-item compared-duration-legend-item"
                            key={index}
                        >
                            <div
                                className="compared-duration-legend-item-title"
                                style={{ color: item.color }}
                            >
                                {item.name}
                            </div>
                            {item.items.map((legendItem) => {
                                return (
                                    <div
                                        className="compared-duration-legend-item-value"
                                        key={legendItem.name}
                                    >
                                        <span
                                            className="item-marker--flat"
                                            style={{
                                                backgroundColor: legendItem.color || "rgb(0, 123, 255)",
                                            }}
                                        />
                                        {legendItem.name}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
